module.exports = __webpack_public_path__ + "img/counter.487f5f06.png";